import type { HarmonyWorkitem, Workitem } from '@rhythmic/db/types'
import type { UseLiveQueryReturn } from '@tanstack/vue-db'
import { eq, useLiveQuery } from '@tanstack/vue-db'

import { HARMONY_WORKITEM_TABLE, WORKITEM_TABLE } from '../collections'
import { useCollection } from '../composables/useCollection'

// harmonyitem is the union of {hid:string, harmony_package_id:string} and Workite
export type HarmonyItem = Workitem & {
  hid: string
  harmony_package_id: string
  column_id?: string
}

export function useHarmonyItems(packageId: string, teamId: string): UseLiveQueryReturn<HarmonyItem> | undefined {
  if (!packageId) {
    return undefined
  }

  const hwi = useCollection<HarmonyWorkitem>(HARMONY_WORKITEM_TABLE, {
    harmony_package_id: packageId,
  }).collection

  const workitems = useCollection<Workitem>(WORKITEM_TABLE, {
    team_id: teamId,
  }).collection

  const query = useLiveQuery((builder) =>
    builder
      .from({ h: hwi })
      .innerJoin({ w: workitems }, ({ h, w }) => eq(h.workitem_id, w.id))
      .select(({ h, w }) => ({
        hid: h.id,
        harmony_package_id: h.harmony_package_id,
        ...w,
      })),
  )
  return query
}
